import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as MenuAction from '../actions/MenuAction';
class ManageFormStore extends EventEmitter {
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    pageLoadResponse = ""
    deleteFormResponse = ""
    saveFormNameResponse = ""
    attachmentResponse = ""
    removeAttachmentResponse = ""
    saveImgResponse = ""
    cloneFormResponse = ""
    handleFormStore = (action) => {
        switch (action.action.type) {
            case "formPageLoadResponse": {
                this.pageLoadResponse = action.action.response;
                this.emit('formPageLoadResponse');
                break;
            }
            case "deleteFormResponse": {
                this.deleteFormResponse = action.action.response;
                this.emit('deleteFormResponse');
                break;
            }
            case "saveFormResponse": {
                this.saveFormResponse = action.action.response;
                this.emit('saveFormResponse');
                break;
            }
            case "cloneFormResponse": {
                this.cloneFormResponse = action.action.response;
                this.emit('cloneFormResponse');
                break;
            }
            case "saveFormNameResponse": {
                this.saveFormNameResponse = action.action.response;
                this.emit('saveFormNameResponse');
                break;
            } case "NOTIFY_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('insertFav');
                break;
            }
            case "NOTIFY_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('insertFav');
                break;
            }
            case "NOTIFY_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('currFav');
                break;
            } case "AddForm_UploadAttachments": {
                this.attachmentResponse = action.action.response;
                this.emit('attachmentResponse');
                break;
            }
            case "AddForm_RemoveAttachment": {
                this.removeAttachmentResponse = action.action.response;
                this.emit('rmvAttach');
                break;
            }
            case "saveattachment_Response": {
                this.saveImgResponse = action.action.response;
                this.emit('saveImg');
                break;
            }

        }
    }

}
const objManageForm = new ManageFormStore;
// Dispatcher code
Dispatcher.register(objManageForm.handleFormStore.bind(objManageForm));
export default objManageForm;